import React, { useEffect, useRef, useState } from 'react'
import DateRangePicker from '../../../../components/DataRangePicker'
function DashboardDataRange({onChange = () => {}, dateRange}) {
  const boxRef = useRef(null);
  const [isDateRangeOpen, setDateRangeOpen] = useState(false);
  const [selectedDataRange, setSelectedDataRange] = useState({
    start: new Date(),
    end : new Date()
  }) 

  useEffect(() => {
    if (dateRange) {
      const getSafeDate = (dateStr, fallbackDate) => {
        const date = new Date(dateStr);
        return isNaN(date.getTime()) ? fallbackDate : date;
      };

      // Hoy a las 00:00:00
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);

      // Hoy a las 23:59:59
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 59, 999);

      setSelectedDataRange({
        start: getSafeDate(dateRange.startDate, todayStart),
        end: getSafeDate(dateRange.endDate, todayEnd)
      });
    }
  }, [dateRange]);

  const toggleDataRange = () => {
    setDateRangeOpen((prev) => !prev);
  }
  const handleDateRangeClick = (selectedRange) => {
    // Alternar el estado del selector de rango de fechas
    setDateRangeOpen((prev) => !prev);
    if (selectedRange.startDate && selectedRange.endDate) {
      setSelectedDataRange({
      start: selectedRange.startDate,
      end : selectedRange.endDate
    })}
    console.log(selectedRange)
    onChange(selectedRange);
  };

  const handleClickOutside = (event) => {
    if (boxRef.current && !boxRef.current.contains(event.target)) {
      setDateRangeOpen(false);
    }
  };
  
  useEffect(() => {
    if (isDateRangeOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDateRangeOpen]);

  return (
    <div className='relative cursor-pointer' >
      <div className='border-b-2 w-96 text-center basis-1/3' onClick={toggleDataRange}>
        <span className=' my-auto '  >{selectedDataRange.start.toLocaleDateString()} - {selectedDataRange.end.toLocaleDateString()}</span>
      </div>
      {isDateRangeOpen && (
        <div className=" absolute z-50 -left-1/3 mt-2 w-[40rem] bg-white border border-gray-300 rounded shadow-lg">
          <DateRangePicker
            onChange={(selectedRange) => { handleDateRangeClick(selectedRange)}}
            closeWindow={() => setDateRangeOpen(false)}
            options={dateRange} 
          />
        </div>
      )}
      
    </div>
  )
}

export default DashboardDataRange